import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLine5 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
			fill: "#FF5A00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5105 14.4642C16.5105 12.4745 15.0467 10.4661 11.4238 10.2783L11.0484 10.2597L11.2359 7.72565H16.0036V5.52939H9.03994L8.51429 12.4182L10.5791 12.4367C13.0192 12.4555 13.6573 13.7695 13.6573 14.7266C13.6573 16.2848 12.3621 16.8665 11.3299 16.8665C10.2037 16.8665 9.4529 16.4536 8.81455 16.0218L7.83838 18.0866C8.8709 18.6683 10.0722 19.044 11.4799 19.044C14.502 19.0443 16.5105 16.9983 16.5105 14.4642Z",
			fill: "black"
		})
	]
});
const ForwardRef = forwardRef(SvgLine5);
export { ForwardRef as ReactComponent };
